import { request } from "./request";

const BASE_URL = "/api/notifications";

export default {
  async fetchAll() {
    return await request(BASE_URL);
  },

  async markAsRead(targetId, type) {
    return await request({
      url: `${BASE_URL}/mark_as_read`,
      method: "PUT",
      data: { target_id: targetId, type: type },
    });
  },
};
